import React , { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const errorObj = [{
        error: 'User Okta profile not setup',
        code: "USER_NOT_IN_TOOL"
    },{
        error: "User doesn't have company assigned",
        code: "USER_COMPANY_EMPTY"
    },{
        error: 'Company is not available in the Application',
        code: "COMPANY_NOT_IN_TOOL"
    },{
        error: 'Company is not available in the Application',
        code: "COMPANY_NOT_MATCH"
    },{
        error: "Tow items not available for this company",
        code: "COMPANY_EMPTY_TOWITEMS"
    }
];
export default class CompanyNotFound extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorText: '',
            error: ''
        };
    }
    componentWillMount() {
        let locationObj = this.props.location && this.props.location.state ? this.props.location.state.errorHandler.code : '';
        errorObj.map((val) => {
            if(val.code === locationObj) {
                this.setState({error: val, errorText: val.error});
            }

            return true;
        })      
    }
    render() {
        let imgSrc = this.state.error && this.state.error.code === 'COMPANY_EMPTY_TOWITEMS' ? "./images/tow-item-not-found.svg" : (this.state.error.code === 'USER_COMPANY_EMPTY' ? "./images/not-assigned.svg" : '');
        return (
            <div>
                <div className="error-wrapper">
                    <div className="error-wrapper-content">
                        <img alt='error company not found' src={imgSrc} className="error-img towiems-notassigned-img" />
                        <h1 className="error-wrapper-title"> { this.state.errorText } </h1>
                        <h3><a href="" className="contact-admin-link">Contact Admin</a></h3>
                        <button type="button" className="btn btn-primary">
                            <Link to='/login'>BACK TO HOME</Link>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

CompanyNotFound.propTypes = {
    location: PropTypes.object
}


// WEBPACK FOOTER //
// ./src/containers/CompanyNotFound/index.js